import { Component, OnInit } from '@angular/core';
import { Protocolo, ProtocoloEstados } from './protocolo.model';
import { ActivatedRoute, Router } from '@angular/router';
import { adicionaIconesGrid, GridConfig } from '../app.config';
import { ProtocoloMotivoService } from '../protocolo-motivo/protocolo-motivo.service';
import { ContratosService } from '../contratos/contratos.services';
import { ProtocoloService } from './protocolo.service';
import { ProtocoloAtendimentoTipoService } from '../protocolo-atendimento-tipo/protocolo-atendimento-tipo.service';
import { ServicoService } from '../servico/servico.service';
import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { NTECH_API } from '../app.api';
import 'rxjs/add/operator/timeout';
import notify from 'devextreme/ui/notify';
import { listaEstadosAndamento } from '../shared/listas-parametros';

@Component({
  selector: 'ntc-protocolo',
  templateUrl: './protocolo.component.html',
  styleUrls: ['./protocolo.component.css']
})
export class ProtocoloComponent implements OnInit {

  protocolo: Protocolo;
  tab = [true, false, false, false, false];
  itemsForm = [];
  // listaContrato = [];
  listaContrato: any = {};
  listaMotivo = [];
  listaStatus = [
    {Nome: 'Contrato', Status: true},
    {Nome: 'ProtocoloMotivo', Status: false},
    {Nome: 'Protocolo', Status: false},
    {Nome: 'ProtocoloAtendimentoTipo', Status: false},
    {Nome: 'Servico', Status: false}
  ];

  listaServico = [];
  listaProtocoloAtendimentoTipo = [];

  listaProtocoloAtendimentoCanal = [
    {Id: 1, DescricaoProtocoloAtendimentoCanal: 'Telefone'},
    {Id: 2, DescricaoProtocoloAtendimentoCanal: 'Internet'},
    {Id: 3, DescricaoProtocoloAtendimentoCanal: 'Mobile'},
    {Id: 4, DescricaoProtocoloAtendimentoCanal: 'Desktop'},
    {Id: 5, DescricaoProtocoloAtendimentoCanal: 'Totem'}
  ];

  listaEvento = [
    {Id: 1 , DescricaoEvento: 'Criação'},
    {Id: 2 , DescricaoEvento: 'Agendamento'},
    {Id: 3 , DescricaoEvento: 'Execução'},
    {Id: 4 , DescricaoEvento: 'Cancelamento'},
    {Id: 5 , DescricaoEvento: 'Ocorrência'}
  ];

  listaEstadosAndamento = listaEstadosAndamento;

  constructor(
    private protocoloService: ProtocoloService,
    private protocoloMotivoService: ProtocoloMotivoService,
    private contratoService: ContratosService,
    private protocoloAtendimentoTipoService: ProtocoloAtendimentoTipoService,
    private servicoService: ServicoService,
    private router: Router,
    private route: ActivatedRoute,
    http: Http
  ) {
    this.protocolo = new Protocolo;

    this.listaContrato.store = new CustomStore({
      key: 'Id',
      load: function (loadOptions: any) {
          let params = '?';

          params += '_start=' + loadOptions.skip || 0;
          params += '&_limit=' + loadOptions.take || 12;

          // http://ntechsolucoes.com.br:64852/contratos?_start=4&_limit=2

          if (loadOptions.searchValue)  {
            params += '&q=' + loadOptions.searchValue;
          }

          return http.get(`${NTECH_API}/contratos${params}`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      },
      byKey: function (key) {
          return http.get(`${NTECH_API}/contratos/${key.toString()}`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  gravar = function(params: any) {
    const result = params.validationGroup.validate();

    if (result.isValid) {
      // Verificar se existe cadastro de servico, se existir verificar se existe agendamento.
      if (
        (( this.protocolo.ProtocoloServico.length === 0 ) &&  ( this.protocolo.ProtocoloAgendamento.length === 0 )) ||
        (( this.protocolo.ProtocoloServico.length > 0 ) && ( this.protocolo.ProtocoloAgendamento.length > 0 ))
      ) {
        // Existe mais de um servico e mais de um agendamento OU Não existe nem agendamento e nem servico
        this.sResultado = 'Válido!';

        // Verificar estados andamento
        if ( this.protocolo.ProtocoloEstados.length === 0 ) {
          // Adicionar todos os estados
          // Pendente
          const AxPendente   = new ProtocoloEstados();
          AxPendente.IdEstadosAndamento = 1;
          AxPendente.DtHrProtocoloEstado = new Date();
          this.protocolo.ProtocoloEstados.push(AxPendente);

          // Procedente
          const AxProcedente = new ProtocoloEstados();
          AxProcedente.IdEstadosAndamento = 3;
          AxProcedente.DtHrProtocoloEstado = new Date();
          AxProcedente.DtHrProtocoloEstado.setSeconds(AxProcedente.DtHrProtocoloEstado.getSeconds() + 1);
          this.protocolo.ProtocoloEstados.push(AxProcedente);

          // Agendado
          const AxAgendado   = new ProtocoloEstados();
          AxAgendado.IdEstadosAndamento = 2;
          AxAgendado.DtHrProtocoloEstado = new Date();
          AxAgendado.DtHrProtocoloEstado.setSeconds(AxAgendado.DtHrProtocoloEstado.getSeconds() + 2);
          this.protocolo.ProtocoloEstados.push(AxAgendado);
        } else if (this.protocolo.ProtocoloEstados.length > 0) {
          // procura por estados e se nao encontrar criar
          // Pendente
          if (!this.protocolo.ProtocoloEstados.find((fItem) => fItem.IdEstadosAndamento === 1) ) {
            const AxPendente   = new ProtocoloEstados();
            AxPendente.IdEstadosAndamento = 1;
            AxPendente.DtHrProtocoloEstado = new Date();
            this.protocolo.ProtocoloEstados.push(AxPendente);
          }
          // Procedente
          if (!this.protocolo.ProtocoloEstados.find((fItem) => fItem.IdEstadosAndamento === 3) ) {
            const AxProcedente   = new ProtocoloEstados();
            AxProcedente.IdEstadosAndamento = 3;
            AxProcedente.DtHrProtocoloEstado = new Date();
            AxProcedente.DtHrProtocoloEstado.setSeconds(AxProcedente.DtHrProtocoloEstado.getSeconds() + 1);
            this.protocolo.ProtocoloEstados.push(AxProcedente);
          }
          // Agendado
          if (!this.protocolo.ProtocoloEstados.find((fItem) => fItem.IdEstadosAndamento === 2) ) {
            const AxAgendado   = new ProtocoloEstados();
            AxAgendado.IdEstadosAndamento = 2;
            AxAgendado.DtHrProtocoloEstado = new Date();
            AxAgendado.DtHrProtocoloEstado.setSeconds(AxAgendado.DtHrProtocoloEstado.getSeconds() + 2);
            this.protocolo.ProtocoloEstados.push(AxAgendado);
          }
        }

        this.protocoloService.gravarProtocoloSistema(this.protocolo)
        .subscribe((ret: Protocolo) => {
          this.router.navigate(['/protocolos']);
        });
      } else {
        this.sResultado = 'Inválido!';
        notify(`É necessário realizar um agendamento com o cliente para executar os serviços.`, 'error', 2000);
      }
    } else {
      this.sResultado = 'Inválido!';
      notify(`Erro ao gravar Protocolo`, 'error', 2000);
    }
  };

  montaForm(Select = null) {
    if (Select !== null) {
      const foundItem = this.listaStatus.find((fItem) => fItem.Nome === Select);
      if (foundItem) {
        foundItem.Status = true;
      }
    }

    if (
      (this.listaStatus[0].Status === true ) &&
      (this.listaStatus[1].Status === true) &&
      (this.listaStatus[2].Status === true) &&
      (this.listaStatus[3].Status === true) &&
      (this.listaStatus[4].Status === true)
    ) {

      this.itemsForm = [
        {
          dataField: 'Id',
          editorType: 'dxTextBox',
          label: { text: 'ID' },
          editorOptions: { disabled: true }
        },
        {
          dataField: 'IdContrato',
          editorType: 'dxLookup',
          label: { text: 'Contrato' },
          editorOptions: {
            // items: this.listaContrato,
            dataSource: this.listaContrato,
            // displayExpr: 'Id',
            displayExpr: function (data) {
              if (data !== undefined) {
                return data.Id + ' - ' + data.DescricaoContrato;
              } else {
                return data;
              }
            },
            valueExpr: 'Id',
            value: this.protocolo.IdContrato
          },
          validationRules: [{
            type: 'required',
            message: 'Contrato é obrigatório.'
          }]
        },
        {
          dataField: 'IdProtocoloMotivo',
          editorType: 'dxLookup',
          label: { text: 'Motivo' },
          editorOptions: {
            items: this.listaMotivo,
            displayExpr: 'DescricaoProtocoloMotivo',
            valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Motivo do protocolo é obrigatório.'
          }]
        },
      ];
    }
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  ngOnInit() {
    this.protocoloMotivoService.getProtocoloMotivos().subscribe(
      protocoloMotivos => {
        this.listaMotivo = protocoloMotivos;
        this.montaForm('ProtocoloMotivo');
      }, erro => {
        this.montaForm('ProtocoloMotivo');
      }
    );
/*
    this.contratoService.getContratos().subscribe(
      contratos => {
        this.listaContrato = contratos;
        this.montaForm('Contrato');
      }, erro => {
        this.montaForm('Contrato');
      }
    );
*/
    this.protocoloAtendimentoTipoService.getProtocoloAtendimentoTipos().subscribe(
      protocoloAtendimentoTipos => {
        this.listaProtocoloAtendimentoTipo = protocoloAtendimentoTipos;
        this.montaForm('ProtocoloAtendimentoTipo');
      }, erro => {
        this.montaForm('ProtocoloAtendimentoTipo');
      }
    );

    this.servicoService.getServicos().subscribe(
      servicos => {
        this.listaServico = servicos;
        this.montaForm('Servico');
      }, erro => {
        this.montaForm('Servico');
      }
    );

    // Carregar dados se for alteracao
    if (this.route.snapshot.params['id'] !== undefined) {
      this.protocoloService.getProtocoloById(this.route.snapshot.params['id'])
        .subscribe(protocolo => {
          this.protocolo = protocolo;
          this.montaForm('Protocolo');
        });
    } else {
      this.montaForm('Protocolo');
    }

    this.tabAtivo(0);
  }

  onInitNewRowEvento = function(e){
    e.data.DtHrEvento = new Date();
  };

  onInitNewRowAtendimento(e) {
    e.data.DtHrAtendimento = new Date();
  }

  onInitNewRowAgendamento(e) {
    e.data.DtHrCadastro = new Date();
  }

  onInitNewRowEstados(e) {
    e.data.DtHrProtocoloEstado = new Date();
  }

  tabAtivo(tabIndex) {
    for (const i in this.tab) {
        this.tab[i] = false;
    }

    this.tab[tabIndex] = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/protocolo/protocolo.component.ts